import { Heading, HeadingProps } from '../../../../atoms';

export function OutletHeaderHeading(props: HeadingProps): JSX.Element {
  return <Heading variant="h3" {...props} />;
}
